import { BookingAccessControlClaims } from '../booking-access-control-token'
import { bookingAccessControlClaimsSchema } from './booking-access-control-claims-schema'

export const typeChecker = {
  isBookingRoleToken: (claims: unknown, scopeId: string): claims is BookingAccessControlClaims => {
    return bookingAccessControlClaimsSchema.isValidSync(claims, { context: scopeId, scopeType: 'booking' })
  },
}
